import moment from 'moment';

export default {
  init() {

    function detectMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(function (toMatchItem) {
        return navigator.userAgent.match(toMatchItem);
      });
    }

    function expDate(stringDate){
      var nowDate = new Date();
      var date = new Date(stringDate);
      var hours = Math.abs(nowDate - date) / 36e5;

      if(hours > 1)
        return true

      return false
    }

    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function saveParameterByName(name) {
      var result = getParameterByName(name);
      if(result){
        localStorage.setItem(name, JSON.stringify({"result" : result , "date" : new Date()}));
      }
      else{
        var result = JSON.parse(localStorage.getItem(name));
        if(result && expDate(result.date))
          localStorage.removeItem(name);
      }

    }

    const urlParams = new URLSearchParams(window.location.search);
    saveParameterByName('ref');
    saveParameterByName('utm_source');
    saveParameterByName('utm_medium');
    saveParameterByName('utm_campaign');
    saveParameterByName('utm_content');
    saveParameterByName('utm_term');

    jQuery( "#whatsapp_icon" ).append( "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"46\" height=\"46\" fill=\"none\" viewBox=\"0 0 46 46\">\n" +
      "    <path fill=\"#62CC59\" d=\"M23.418 0C10.946 0 .836 10.03.836 22.409c0 4.233 1.182 8.19 3.238 11.57L0 46l12.505-3.971c3.234 1.774 6.956 2.788 10.913 2.788C35.889 44.817 46 34.782 46 22.41 46 10.03 35.89 0 23.418 0zm11.227 30.919c-.53 1.319-2.933 2.52-3.994 2.572-1.06.056-1.089.821-6.862-1.685-5.774-2.512-9.247-8.609-9.52-9.003-.272-.39-2.234-3.187-2.13-6.004.107-2.816 1.647-4.144 2.196-4.694.55-.553 1.178-.652 1.563-.657.456-.009.751-.014 1.084 0 .338.014.84-.07 1.277 1.094.437 1.164 1.483 4.018 1.615 4.314.131.29.216.629.01 1.004-.207.376-.315.61-.61.934-.301.324-.635.723-.902.972-.3.272-.615.573-.296 1.16.315.586 1.404 2.501 3.056 4.078 2.126 2.028 3.961 2.704 4.53 3.01.567.309.905.271 1.253-.095.347-.37 1.502-1.614 1.91-2.173.409-.559.789-.45 1.31-.24.52.212 3.3 1.7 3.867 2.01.568.305.944.464 1.08.708.136.23.094 1.376-.437 2.695z\"/>\n" +
      "</svg>" );



    // ------ Google Analytics top menu events ------ ////
    // $('.nav-item').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Top Menu',
    //     event_label: e.target.innerHTML
    //   });
    // });
    //
    // $('.special-container').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Top Menu',
    //     event_label: e.target.innerHTML
    //   })
    // });
    //
    // $('.simplefavorite-button').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Car box',
    //     event_label: 'אהבתי'
    //   })
    // });
    //
    // $('.compare-button').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Car box',
    //     event_label: event.target.innerHTML
    //   })
    // });
    //
    // $('.car_single_btn').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Car box',
    //     event_label: event.target.innerHTML
    //   })
    // });
    //
    // $('.contact-us-private-lease').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Car box',
    //     event_label: event.target.innerHTML
    //   })
    // });
    //
    // $('.youtube-follow').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Bottom menu',
    //     event_label: 'youtube'
    //   })
    // });
    //
    // $('.facebook-follow').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Bottom menu',
    //     event_label: 'facebook'
    //   })
    // });
    //
    // $('.child-item-span').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Bottom menu',
    //     event_label: e.target.innerHTML
    //   })
    // });
    //
    // $('.phone-contact').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Bottom menu',
    //     event_label: 'טלפון'
    //   })
    // });
    //
    // $('.whatsapp-contact').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Bottom menu',
    //     event_label: 'whatsapp'
    //   })
    // });
    //
    // $('.find-a-car').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Find me a car',
    //     event_label: e.target.innerHTML
    //   })
    // });
    //
    // $('.sticky-button').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Schedule meeting button',
    //     event_label: 'Main button'
    //   })
    // });
    //
    // $('.single-car-sched-meet').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Schedule meeting button',
    //     event_label: this.dataset.car
    //   });
    // });
    //
    // $('.contact-us-mail').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Email',
    //     event_label: e.target.innerHTML
    //   });
    // });
    //
    // $('.full-article').on('click', function (e) {
    //   gtag('event', 'Click', {
    //     event_category: 'Full article',
    //     event_label: this.dataset.title
    //   });
    // });
    function extractNumberFromElement(elementId) {
      var element = document.getElementById(elementId);
      if (!element) {
          console.error('Element not found: ' + elementId);
          return null;
      }
  
      var text = element.textContent || element.innerText;
      var justNumbers = text.replace(/[^\d.,]/g, '');
  
      // Assuming numbers use commas for thousands and no decimal points.
      var number = parseInt(justNumbers.replace(/,/g, ''));
  
      return isNaN(number) ? null : number;
  }

  
  // Variables 
  let deposit_value_1 ; 
  let monthly_value_1 ;
  let payment_value_1 ;
  let result_value_1 ; 
  let display_finally_result_1 ;


  jQuery(document).ready(function($) {
    // Log that the script is running
    console.log('jQuery is ready.');
    $('.hide').css('display', 'none')

    // Toggle mobile navigation menu manually
    $(document).on('click', '.header-mobile .hamburger', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const target = $('#navbarNavDropdown');
      $(this).toggleClass('collapsed');
      target.toggleClass('show');
    });

    // Toggle mobile submenu on click
    $(document).on('click', '.mobile-menu-links .mobile-dropdown-toggle-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const parentLi = $(this).closest('.dropdown');
      const dropdownMenu = parentLi.find('.dropdown-menu').first();

      // Toggle current dropdown
      parentLi.toggleClass('show');
      dropdownMenu.toggleClass('show');

      // Close other mobile dropdowns if any
      $('.mobile-menu-links .dropdown').not(parentLi).removeClass('show');
      $('.mobile-menu-links .dropdown-menu').not(dropdownMenu).removeClass('show');
    });

    // When the toggle button is clicked
    $('#toggle-button').click(function() {
      console.log('Toggle button clicked.');

      // Toggle the visibility of the .hide element
      $('.hide').toggle(); // Toggles between display: none and display: block

      // Log the visibility state
      if ($('.hide').is(':visible')) {
        console.log('Content is now visible.');
      } else {
        console.log('Content is now hidden.');
      }
    });
  });

  jQuery(document).on('finalResultCalculated', function(event, finalResult) {  
    // Assuming you want to update some element in the DOM
    // Update display_finally_result_1 with the received finalResult
    display_finally_result_1 = finalResult;
});

  
  jQuery('input').on('input', function(e) {
      // Update values whenever any input changes
      updateValues();
  });
    
  function updateValues() {
      // Update your variables and logic here
      let deposit_value_1, monthly_value_1, payment_value_1;

      const depositElement = document.getElementById('deposit_value');
      const monthlyElement = document.getElementById('monthly_value');
      const paymentElement = document.getElementById('payment_value');
      
      if (depositElement) {
          deposit_value_1 = depositElement.value.replace(/,/g, '');
      } 
      if (monthlyElement) {
          monthly_value_1 = monthlyElement.value.replace(/,/g, '');
      } 
      if (paymentElement) {
          payment_value_1 = paymentElement.value.replace(/,/g, '');
      }
      if (result_value_1 && display_finally_result_1){
        result_value_1 = extractNumberFromElement('result_car_deposit');
        display_finally_result_1 = extractNumberFromElement('display_finnaly_result');
      }
    }
  

    var compare_count = 0;
    if (localStorage.getItem('image_compare_1')) {
      compare_count++;
    }
    if (localStorage.getItem('image_compare_2')) {
      compare_count++;
    }
    if (window.location.pathname.indexOf('compare') > 0) {
      compare_count = 2;
    }
    jQuery('.banner .header-wrapper .header-content .user-section .special-container.comparation .number')[0].innerText = compare_count;

    //// ---- Contact us form GTAG event ---- /////

    var wpcf7Elm = document.querySelector('.wpcf7');
    wpcf7Elm.addEventListener('wpcf7submit', function (event) {
      // Only if form is valid
      if (
        event.detail.inputs[0].value != '' &&
        event.detail.inputs[1].value != '' &&
        event.detail.inputs[2].value != '' &&
        (event.detail.inputs[9].name == "checkbox-177[]" || event.detail.inputs[8].name == 'checkbox-177[]')) {
        const path = window.location.pathname
        if (path == '/about/' || path == '/blog/' || path == '/car/' || path == '/') {
          // gtag('event', 'Submission', {
          //   event_category: 'Contact - us',
          //   event_label: $('.selected').last().text()
          // });
          return;
        } else {
          let lead = ''
          if (path == '/private-leasing/') {
            lead = 'private leasing'
          } else {
            if ($('.km-number').html() == '0 ק״מ') {
              lead = 'new car'
            } else {
              lead = 'used car'
            }
          }
          // gtag('event', 'Submission', {
          //   event_category: 'Contact - us',
          //   lead: lead,
          // })
        }
      }
    }, false);

    $('.logo').on('click', function (e) {
      // gtag('event', 'Click', {
      //   event_category: 'Main Logo',
      // });
    });

    $('.sf-field-sort_order').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      setTimeout(() => {
        // gtag('event', 'Click', {
        //   event_category: 'Car sorting',
        //   event_label: e.target.innerHTML
        // })
      }, 5000);
    });

    $('.fund-calculator').on('click', function (e) {
      // gtag('event', 'Click', {
      //   event_category: 'Calculator',
      // });
    });

    /*Cta Button*/
    $('.wrap > .sticky-button').click(function () {
      if (detectMobile()) {
        $(".show_contact_cta").animate({"left": "0px"}, 1000);
      } else {
        $(".show_contact_cta").animate({"left": "0px"}, 1000);
      }
      $(".show_contact_cta").css("display", "grid")
      $('.shadow_cta').fadeIn(1000);
    });
    $('.car_single_btn > .contact-us-private-lease').click(function () {
      if (detectMobile()) {
        $(".show_contact_cta").animate({"left": "0px"}, 1000);
      } else {
        $(".show_contact_cta").animate({"left": "0px"}, 1000);
      }
      $(".show_contact_cta").css("display", "grid")
      $('.shadow_cta').fadeIn(1000);
    });

    $('.shadow_cta').click(function () {
      $(".show_contact_cta").animate({"left": "-404px"}, 1000);
      $('.shadow_cta').fadeOut(1000);
    });

    $('.show_contact_cta .close').click(function () {
      $(".show_contact_cta").animate({"left": "-410px"}, 1000);
      $('.shadow_cta').fadeOut(1000);
    });


    /*back to top*/

    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.back-to-top').fadeIn();
      } else {
        $('.back-to-top').fadeOut();
      }
    });

    $(".back-to-top").click(function () {
      $("html, body").animate({scrollTop: 0}, 1000);
    });


    // Going to '/compare' page on condition
    $("body > header > div.header-wrapper > div > div > div.user-section.d-none.d-lg-flex > div.special-container.comparation").click(function (event) {
      if ($("body > header > div.header-wrapper > div > div > div.user-section.d-none.d-lg-flex > div.special-container.comparation > span").text() == 2) {
        /*Car 1*/
        var check_car_1 = $('.compare_1.same_bxk .hidden_element .item_car2').html();
        var km_car_1 = $('.compare_1.same_bxk .hidden_element .item_car4').html();
        var location_car_1 = $('.compare_1.same_bxk .hidden_element .item_car3').html();
        var people_car_1 = $('.compare_1.same_bxk .hidden_element .item_car5').html();
        var price_car_1 = $('.compare_1.same_bxk .hidden_element .item_car1').html();
        var promotions_car_1 = $('.compare_1.same_bxk .hidden_element .item_car_promotions').html();
        var warrnety_months_1 = $('.compare_1.same_bxk .hidden_element .warrnety_months').html();

        var aa_car_1 = $('.compare_1.same_bxk .hidden_element .item_1').html();
        var engine_car_1 = $('.compare_1.same_bxk .hidden_element .item_2').html();
        var gearbox_car_1 = $('.compare_1.same_bxk .hidden_element .item_3').html();
        var oil_car_1 = $('.compare_1.same_bxk .hidden_element .item_4').html();
        var color_car_1 = $('.compare_1.same_bxk .hidden_element .item_5').html();

        var car_discount_1 = $('.compare_1.same_bxk .hidden_element .item_car6').html();
        /*Car 2*/
        var check_car_2 = $('.compare_2.same_bxk .hidden_element .item_car2').html();
        var km_car_2 = $('.compare_2.same_bxk .hidden_element .item_car4').html();
        var location_car_2 = $('.compare_2.same_bxk .hidden_element .item_car3').html();
        var people_car_2 = $('.compare_2.same_bxk .hidden_element .item_car5').html();
        var price_car_2 = $('.compare_2.same_bxk .hidden_element .item_car1').html();
        var promotions_car_2 = $('.compare_2.same_bxk .hidden_element .item_car_promotions').html();
        var warrnety_months_2 = $('.compare_2.same_bxk .hidden_element .warrnety_months').html();

        var aa_car_2 = $('.compare_2.same_bxk .hidden_element .item_1').html();
        var engine_car_2 = $('.compare_2.same_bxk .hidden_element .item_2').html();
        var gearbox_car_2 = $('.compare_2.same_bxk .hidden_element .item_3').html();
        var oil_car_2 = $('.compare_2.same_bxk .hidden_element .item_4').html();
        var color_car_2 = $('.compare_2.same_bxk .hidden_element .item_5').html();

        var car_discount_2 = $('.compare_2.same_bxk .hidden_element .item_car6').html();

        /* Car Compare 1*/
        var path_image_1 = $('.compare_1.same_bxk > img').attr('src');
        var name_car_1 = $('.compare_1.same_bxk > h3').text();

        /*Car Compare 2*/
        var path_image_2 = $('.compare_2.same_bxk > img').attr('src');
        var name_car_2 = $('.compare_2.same_bxk > h3').text();

        //Get link to car
        var car_link_1 = '';
        var car_link_2 = '';

        $('.each_part_car.active_hover .car_single_btn a').each(function (index) {
          if (!index) {
            car_link_1 = $(this).attr("href");
          } else {
            car_link_2 = $(this).attr("href");
          }
        })

        $.ajax({
          type: "GET",
          async: true,
          url: "/compare",
          data: {
            car_link_1: car_link_1,
            car_image_1: path_image_1,
            car_title_1: name_car_1,
            check_car_1: check_car_1,
            location_car_1: location_car_1,
            km_car_1: km_car_1.split(" ")[0],
            people_car_1: people_car_1,
            price_car_1: price_car_1.split(" ")[0],
            car_discount_1: car_discount_1,
            aa_car_1: aa_car_1,
            engine_car_1: engine_car_1,
            gearbox_car_1: gearbox_car_1,
            oil_car_1: oil_car_1,
            color_car_1: color_car_1,
            promotions_car_1: promotions_car_1,
            warrnety_months_1: warrnety_months_1,
            car_link_2: car_link_2,
            car_image_2: path_image_2,
            car_title_2: name_car_2,
            check_car_2: check_car_2,
            location_car_2: location_car_2,
            km_car_2: km_car_2.split(" ")[0],
            people_car_2: people_car_2,
            price_car_2: price_car_2.split(" ")[0],
            car_discount_2: car_discount_2,
            aa_car_2: aa_car_2,
            engine_car_2: engine_car_2,
            gearbox_car_2: gearbox_car_2,
            oil_car_2: oil_car_2,
            color_car_2: color_car_2,
            promotions_car_2: promotions_car_2,
            warrnety_months_2: warrnety_months_2
          },
          success: function (msg) {
            window.location.href = '/compare';
          },
          error: function (err) {
          }
        });
      }

      if ($("body > header > div.header-wrapper > div > div > div.user-section.d-none.d-lg-flex > div.special-container.comparation > span").text() < 2) {
        alert('אנא בחר ברכב נוסף על מנת לבצע את ההשוואה')
      }
    })

    $('.simplefavorite-button').click(function () {
      var count_favorites_post = parseInt($('.special-container.favorites .number').html());
      if ($(this).hasClass('active')) {
        $('.special-container.favorites .number').html(count_favorites_post -= 1);
      } else {
        $('.special-container.favorites .number').html(count_favorites_post += 1);
      }
    });

    $('.filtre_branch form .sf-field-taxonomy-branch_taxonomy select').select2();

    // Create the select lists with the required design.
    if ($('.wpcf7-select').length > 0) {
      addDatesAndHours()
      $('.wpcf7-select').each(function () {
        createLubinskiSelect(this.id);
      });
    }

    function addDatesAndHours() {
      var defaultOption = `<option value = "תאריך">תאריך</option>`
      $('#date').html(defaultOption)
      for (let i = 0; i <= 30; i++) {
        var date = moment().add(i, 'days');
        var day = date.day();
        if (day !== 6) {
          var dateForDisplay = date.format("DD/MM")
          var dateOption = `<option value=${dateForDisplay}>${dateForDisplay}</option>`
          $('#date').append(dateOption)
        }
      }
    }

    // Checking checkbox when clicking on checkbox text.
    if ($('.wpcf7-checkbox').length > 0) {
      $('span.wpcf7-list-item-label > .form_check').on('click', function () {
        this.parentElement.previousSibling.checked = !this.parentElement.previousSibling.checked;
      });
    }

    function hideAllSelects() {
      $('.wpcf7-form-control-wrap.date').hide();
      $('.wpcf7-form-control-wrap.hour').hide();
      $('.wpcf7-form-control-wrap.details-contact').hide();
    }

    function removeExtraClasses() {
      if ($('.contact-us-container .wpcf7 .lubinski-select')[0].classList.contains('book-meeting')) {
        $('.contact-us-container .wpcf7 .lubinski-select')[0].classList.remove('book-meeting');
      }
      if ($('.contact-us-container .wpcf7 .lubinski-select')[0].classList.contains('customer-service')) {
        $('.contact-us-container .wpcf7 .lubinski-select')[0].classList.remove('customer-service');
      }
      if ($('.contact-us-container .wpcf7 .lubinski-select')[0].classList.contains('return-to-me')) {
        $('.contact-us-container .wpcf7 .lubinski-select')[0].classList.remove('return-to-me');
      }
    }

    function createLubinskiSelect(selectElement) {
      var optionValues = [];
      $('#' + selectElement + ' option').each(function (el) {
          if (el !== 0) {
              var optionElement = "<div class='option-element'>" + this.value + "</div>";
              optionValues.push(optionElement);
          }
      });
      $('#' + selectElement).parent().append('<div class="lubinski-select" id="lubinski' + selectElement + '"><div class="selected-option">' + $('#' + selectElement + ' option')[0].innerHTML + '</div></div>');
      $('#lubinski' + selectElement).append('<div class="lubinski-select-values">' + optionValues.join("") + '</div>');
  
      if (!detectMobile()) {
          var selectHour = $('#lubinskihour').clone();
          $('#lubinskihour').remove();
          $('.wpcf7-form-control-wrap.date').append(selectHour);
      }
      $('#lubinski' + selectElement).on('click', function () {
          this.classList.toggle('open');
          var displayValues = $(this).find('.lubinski-select-values').css('opacity');
          $(this).find('.lubinski-select-values').css({
              'opacity': displayValues === '0' ? '1' : '0',
              'max-height': displayValues === '0' ? '500px' : '0',
              'visibility': displayValues === '0' ? 'visible' : 'hidden'
          });
          $('#lubinskidate > .lubinski-select-values, #lubinskihour > .lubinski-select-values').css('max-height', '250px');
      });
  
      $('#lubinskidate, #lubinskihour-input').hide()

      // Attach event handler to option elements
      $('#lubinski' + selectElement + ' .option-element').on('click', function () {
          var selectedOption = this.innerHTML;
          $('#' + selectElement).val(selectedOption);
          $('#lubinski' + selectElement + ' .selected-option').addClass('selected').html(selectedOption);
  
        // Hide the elements by default when any option is clicked
        if (selectElement === 'request-type') {
          // Additional logic for when 'request-type' select changes...
          // Check if the selected option is "אני רוצה להגיע לסניף"
            if (selectedOption === 'אני רוצה להגיע לסניף' || selectedOption === 'תגיעו אליי עד הבית לנסיעת מבחן') {
              $('#lubinskidate').show()
              $('#lubinskihour-input').show()
              if (window.innerWidth <= 768) {
                // Ensure the display property is set to block
                $('#lubinskidate').css({
                  'display': 'inline-grid !important',
                  'margin-top':'-3%',
                  'width': '100%', // Use full width for mobile
                  'margin-bottom': '10px' // Add some space between the elements
                });
                $('#lubinskihour-input').css({
                  'display': 'inline-grid',
                  'width': '100%', // Use full width for mobile
                  'margin-bottom': '10px' // Add some space between the elements
                });
                $('#lubinskirequest-type').css({
                  'margin-bottom': '-23%'
                })
              }else{
                // If it is, change the display of the specified elements to 'inline-block'
                $('#lubinskidate').css('display', 'inline-block !important');
                $('#lubinskihour-input').css('display', 'inline-block !important');
                // Assuming you can identify a common parent element directly
                $('#lubinskidate, #lubinskihour-input').parent().css({
                    'display': 'flex',
                    'align-items': 'center'
                });
                }
            }
            else{
              $('#lubinskidate, #lubinskihour-input').hide()
              $('#lubinskirequest-type').css({
                'margin-bottom': '-55px'
              })
            }
        }
      });  
    }
    // Phone number validation and cleanup functions
    function cleanPhoneNumber(phoneNumber) {
      // Remove special characters like "-", spaces, parentheses, etc.
      // Keep only digits
      if (!phoneNumber) return '';
      return phoneNumber.replace(/[^\d]/g, '');
    }

    function isPhoneNumberValid(phoneNumber) {
      // Check if phone number contains only digits (no letters)
      if (!phoneNumber) return false;
      
      // This regex checks if the string contains ONLY digits
      // Returns true if valid (only numbers), false if contains letters or other non-numeric chars
      const onlyDigitsRegex = /^\d+$/;
      return onlyDigitsRegex.test(phoneNumber);
    }

    function isPhoneNumberFormatValid(phoneNumber) {
      // Check if phone number is in valid Israeli format
      // Accepted formats:
      // 1. 0505555555 (10 digits)
      // 2. 050-5555555 (3 digits - 7 digits)
      
      if (!phoneNumber || typeof phoneNumber !== 'string') return false;
      
      const trimmedPhone = phoneNumber.trim();
      
      // Pattern 1: Exactly 10 digits with no separators (0505555555)
      const pattern1 = /^0\d{9}$/;
      
      // Pattern 2: 3 digits, dash, 7 digits (050-5555555)
      const pattern2 = /^0\d{2}-\d{7}$/;
      
      return pattern1.test(trimmedPhone) || pattern2.test(trimmedPhone);
    }

    function formatPhoneNumber(phoneNumber) {
      // Format phone number to 050-5555555 pattern
      // First clean the number
      const cleaned = cleanPhoneNumber(phoneNumber);
      
      if (!cleaned) return '';
      
      // Format: 3 digits - 7 digits (Israeli phone format)
      // Example: 0501234567 becomes 050-1234567
      if (cleaned.length <= 3) {
        return cleaned;
      } else if (cleaned.length <= 10) {
        return cleaned.slice(0, 3) + '-' + cleaned.slice(3);
      } else {
        // If more than 10 digits, only format the first 10
        return cleaned.slice(0, 3) + '-' + cleaned.slice(3, 10);
      }
    }

    function validateAndCleanPhoneNumber(phoneNumber) {
      //    First check if the format is valid (before cleaning)
      if (!isPhoneNumberFormatValid(phoneNumber)) {
        return {
          isValid: false,
          cleanedNumber: '',
          error: 'מספר הטלפון חייב להיות בפורמט: 0505555555 או 050-5555555'
        };
      }
      
      // If format is valid, clean the phone number
      const cleanedPhone = cleanPhoneNumber(phoneNumber);
      
      // Double check it contains only numbers after cleaning
      if (!isPhoneNumberValid(cleanedPhone)) {
        return {
          isValid: false,
          cleanedNumber: cleanedPhone,
          error: 'מספר הטלפון יכול להכיל ספרות בלבד'
        };
      }
      
      // Verify cleaned phone is exactly 10 digits
      if (cleanedPhone.length !== 10) {
        return {
          isValid: false,
          cleanedNumber: cleanedPhone,
          error:  'מספר הטלפון חייב להכיל 10 ספרות'
        };
      }
      
      return {
        isValid: true,
        cleanedNumber: cleanedPhone,
        error: null
      };
    }
    console.log("check")
    // Function to show error message below phone input
    function showPhoneError(inputElement, errorMessage) {
      if (!inputElement) return;
      
      // Remove any existing error message
      removePhoneError(inputElement);
      
      // Create error message element
      const errorDiv = document.createElement('div');
      errorDiv.className = 'phone-validation-error';
      errorDiv.style.color = '#d32f2f';
      errorDiv.style.fontSize = '14px';
      errorDiv.style.marginTop = '5px';
      errorDiv.style.fontWeight = '500';
      errorDiv.textContent = errorMessage;
      
      // Insert error message after the input or its wrapper
      const wrapper = inputElement.closest('.wpcf7-form-control-wrap') || inputElement.parentElement;
      if (wrapper && wrapper.parentElement) {
        wrapper.parentElement.insertBefore(errorDiv, wrapper.nextSibling);
      } else {
        inputElement.parentElement.appendChild(errorDiv);
      }
      
      // Add red border to input
      inputElement.style.borderColor = '#d32f2f';
    }
    
    // Function to remove error message
    function removePhoneError(inputElement) {
      if (!inputElement) return;
      
      // Remove error message
      const wrapper = inputElement.closest('.wpcf7-form-control-wrap') || inputElement.parentElement;
      if (wrapper && wrapper.parentElement) {
        const existingError = wrapper.parentElement.querySelector('.phone-validation-error');
        if (existingError) {
          existingError.remove();
        }
      }
      
      // Also check direct parent
      const directError = inputElement.parentElement.querySelector('.phone-validation-error');
      if (directError) {
        directError.remove();
      }
      
      // Reset border color
      inputElement.style.borderColor = '';
    }

    // Export functions to global scope for use in other files
    window.cleanPhoneNumber = cleanPhoneNumber;
    window.isPhoneNumberValid = isPhoneNumberValid;
    window.isPhoneNumberFormatValid = isPhoneNumberFormatValid;
    window.formatPhoneNumber = formatPhoneNumber;
    window.validateAndCleanPhoneNumber = validateAndCleanPhoneNumber;
    window.showPhoneError = showPhoneError;
    window.removePhoneError = removePhoneError;

    // Auto-format phone number inputs as user types
    jQuery(document).ready(function($) {
      // Add event listener to all phone input fields
      $(document).on('input', 'input[type="tel"], input.telephone-input, input[name="telephone"]', function(e) {
        const input = $(this);
        const cursorPosition = this.selectionStart;
        const oldValue = input.val();
        const oldLength = oldValue.length;
        
        // Remove error message when user starts typing
        removePhoneError(this);
        
        // Format the phone number
        const formatted = formatPhoneNumber(oldValue);
        
        // Only update if the value actually changed
        if (formatted !== oldValue) {
          input.val(formatted);
          
          // Adjust cursor position after formatting
          const newLength = formatted.length;
          const lengthDiff = newLength - oldLength;
          const newCursorPosition = cursorPosition + lengthDiff;
          
          // Set cursor position (handle edge cases)
          if (newCursorPosition >= 0 && newCursorPosition <= newLength) {
            this.setSelectionRange(newCursorPosition, newCursorPosition);
          }
        }
      });
    });

    // Custom values on contact form
    jQuery(document).ready(function($) {
      
          let tradeFund = 0;
          jQuery(".return-to-me").on('click', function (event) {
            tradeFund = 1;
          });
          jQuery(".send-to-myself").on('click', function (event) {
            tradeFund = 0;
          });
      
          let remainingText = $("#model_car").val();
      // Assign unique IDs to each form's submit button
      $(".wpcf7 .wpcf7-form").each(function(index) {
          $(this).find(".wpcf7-submit").attr("id", "form-submit-" + index);
          $(this).attr("id", "form-" + index);
      });
  
      // Handler for form submissions
      $(".wpcf7 .wpcf7-submit").on('click', function(event) {
          event.preventDefault();
          
          // Get the form ID
          var formId = $(this).closest("form").attr("id");
          
          handleFormSubmit("#" + formId);
      });
  
      function handleFormSubmit(formId) {
          let car_price = "0";
          function updateCarPrice(car_price_html) {
              if (car_price_html[0] !== undefined) {
                  return car_price_html[0].innerText;
              }
              return "0"; // Return a default value if car_price_html is not defined
          }
  
          // Car Details
          let car_modal = "";
          let car_year = "";
          let license_number = "";
          let car_marker = "";
          let finishLevel = "";
          let codeDegem = "";
          let deposit_value_1 = '';
          let monthly_value_1 = '';
          let payment_value_1 = '';
          let result_value_1 = '';
          let display_finally_result_1 = '';
          let selectedBranch = '';
  
          if ($("body > div.wrap > div.content > main > div > div.header-single-car > div > div.title_part.col-12 > h1").length > 0) {
              car_modal = $("body > div.wrap > div.content > main > div > div.header-single-car > div > div.title_part.col-12 > h1")[0].innerText;
              let car_price_html = $("body > div.wrap > div.content > main > div > div.content-single-car > div > div.price-single-car > div.element_price > div.top_price.big_t_price > h3");
              car_price = updateCarPrice(car_price_html);
              car_year = $("body > div.wrap > div.content > main > div > div.content-single-car > div > div.detail_support > div.detail_each_part > div.dt_date > h6")[0].innerText;
              license_number = $("body > div.wrap > div.content > main > div > div.content-single-car > div > div.detail_support > div.detail_each_part > div.license-number")[0].innerText;
              car_marker = $("body > div.wrap > div.content > main > div > div.content-single-car > div > div.detail_support > div.detail_each_part > div.car-marker")[0].innerText;
              finishLevel = $("body > div.wrap > div.content > main > div > div.content-single-car > div > div.single-car-specification.title_h3_sty > div.each_spec_part > div.child_specification.chil_aa > div.left_sepc > p")[0].innerText;
              codeDegem = sessionStorage.getItem('CodeDegem');
          }
  
          // Accessing the 'telephone' field value
          var fullNameinput = $(formId + ' .full-name-input').val();
          var telephoneValueRaw = $(formId + ' .telephone-input').val();
          var phoneInputElement = $(formId + ' .telephone-input')[0];
          
          // Validate and clean phone number
          var phoneValidation = validateAndCleanPhoneNumber(telephoneValueRaw);
          if (!phoneValidation.isValid && telephoneValueRaw) {
            showPhoneError(phoneInputElement, phoneValidation.error);
            return; // Stop form submission if phone is invalid
          }
          var telephoneValue = phoneValidation.cleanedNumber;
          
          // Accessing the 'email' field value
          var emailValue = $(formId + ' .email-input').val();
          var branchSelect = $(formId + ' #branch');
          selectedBranch = branchSelect.val();
  
          $(formId + ' input[name="full-name"]').val(fullNameinput);
          $(formId + ' input[name="phoneNumber"]').val(telephoneValue);
          $(formId + ' input[name="email"]').val(emailValue);
          $(formId + ' input[name="carModel"]').each(function () {
              this.value = sessionStorage.getItem('carModel');
          });
  
          let carPrice = parseFloat(car_price.replace(/,/g, ''));
          $(formId + ' input[name="otherModel"]').val(remainingText);
          $(formId + ' input[name="price"]').val(carPrice);
          $(formId + ' input[name="yearOfManufacturer"]').val(car_year);
          $(formId + ' input[name="manufacturer"]').val(car_marker);
          $(formId + ' input[name="finishLevel"]').val(finishLevel);
  
          // Populate the car price, car year, license number, and car manufacturer for both forms
          $(formId + ' input[name="carPrice"]').val(car_price);
          $(formId + ' input[name="model"]').val(codeDegem);
          $(formId + ' input[name="carYear"]').val(car_year);
          $(formId + ' input[name="licenseNumber"]').val(license_number);
          $(formId + ' input[name="carManufacturer"]').val(car_marker);
  
          // Finance details
          if ($("#deposit_value").length > 0) {
              deposit_value_1 = document.getElementById('deposit_value').value.replace(',',"");
              monthly_value_1 = document.getElementById('monthly_value').value;
              payment_value_1 = document.getElementById('payment_value').value.replace(',',"");
              result_value_1 = extractNumberFromElement('result_car_deposit');
              display_finally_result_1 = extractNumberFromElement('display_finnaly_result');
              $(formId + ' input[name="codeDegem"]').val(codeDegem);
  
              if (deposit_value_1 !== 0 || monthly_value_1 !== 0 || payment_value_1 !== 0) {
                  $(formId + ' input[name="firstPayment"]').each(function () {
                      this.value = deposit_value_1;
                  });
                  $(formId + ' input[name="numOfMonths"]').each(function () {
                      this.value = monthly_value_1;
                  });
                  $(formId + ' input[name="requiredAmountOfMoney"]').each(function () {
                      this.value = result_value_1;
                  });
                  $(formId + ' input[name="monthlyValue"]').each(function () {
                      this.value = display_finally_result_1;
                  });
                  $(formId + ' input[name="paymentEndOfPeriod"]').each(function () {
                      this.value = payment_value_1;
                  });
                  $(formId + ' input[name="fundPriceRequested"]').each(function () {
                      this.value = result_value_1;
                  });
                  $(formId + ' input[name="monthlyRepayment"]').each(function () {
                      this.value = display_finally_result_1;
                  });
                  $(formId + ' input[name="tradeFund"]').each(function(){
                      this.value = tradeFund;
                  });
                  if (tradeFund === 0 || tradeFund === 1) {
                      $(formId + ' input[name="levelOfFinish"]').each(function () {
                          this.value = finishLevel;
                      });
  
                      let fundParametersArray;
                      if (tradeFund == 1) {
                          let carPrice = parseFloat(car_price.replace(/,/g, ''));
                          fundParametersArray = [carPrice, deposit_value_1, monthly_value_1, payment_value_1, result_value_1, display_finally_result_1, car_year, tradeFund, finishLevel];
                          let fundParametersString = fundParametersArray.join(';');
                          $(formId + ' input[name="fundParameters"]').val(fundParametersString);
                      }
                  }
              }
          }
  
          try {
            console.log('Lead')
            var acceptanceCheckbox = $(formId + ' #acceptance-input').is(':checked');
            if (formId === '#form-1' && (telephoneValue || emailValue)) {
                if (telephoneValue && !emailValue) {
                    $('.popup_mailsend h3').text('הצעת מחיר תשלח בנייד');
                } else if (!telephoneValue && emailValue) {
                    $('.popup_mailsend h3').text('הצעת מחיר תשלח במייל');
                } else if (telephoneValue && emailValue) {
                    $('.popup_mailsend h3').text('טופס נשלח בהצלחה');
                }
                $('.popup_mailsend').fadeIn();
                $('.overlay_mailsend').fadeIn();
            } 
            if (formId === '#form-0' && telephoneValue && fullNameinput && acceptanceCheckbox && selectedBranch) {
              $('.popup_mailsend h3').text('טופס נשלח בהצלחה');
              $('.popup_mailsend').fadeIn();
              $('.overlay_mailsend').fadeIn();
            }
        } catch (e) {
            console.log(e);
        }
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'cf7_form_submit',
          formId: formId.replace('#form-', ''),
          formName: 'ContactForm7'
        });
        console.log('dataLayer after push:', dataLayer);
    
        // 2. Facebook Pixel
        if (typeof fbq === 'function') {
          fbq('track', 'Lead');
          fbq('track', 'whatsapp');  // האירוע הנוסף
          console.log('Facebook Pixel event tracked: Lead');
        }
    
        // 3. Google Ads conversions
        if (typeof gtag === 'function') {
          gtag('event', 'conversion', {
            'send_to': 'AW-992836988/9eSUCI_EnHgQ_Pq12QM'
          });
          gtag('event', 'conversion', {
            'send_to': 'AW-992836988/notGCK7D5bQaEPz6tdkD'
          });
          console.log('Google Ads conversion event tracked');
        }

        $(formId).submit();
    }

  });
  
  
      
    $('.favorites_btn').on('click', 'button.simplefavorite-button.active', function () {
      setTimeout(function () {
        location.reload();
      }, 500);
    });

    $('.single-car-favorite').on('click', 'button.simplefavorite-button.active', function () {
      setTimeout(function () {
        location.reload();
      }, 500);
    });

    var integer = parseInt($('.special-container.comparation span').html());

    $('a.compare-button').click(function () {
      // Try to get the car license from the closest container
      var carContainer = $(this).closest('.each_part_car');
      var carLicense = carContainer.data('license');
      let carImage = carContainer.data('image');   // Retrieves data-image
      let carId    = carContainer.data('postid');    // Retrieves data-postid
      let carTitle = carContainer.data('title');     // Retrieves data-title

      // Fallback: get the license from the compare-button's own data attribute if not set
      if (!carLicense) {
        carLicense = $(this).data('license');
        carImage = $(this).data('image');
        carId = $(this).data('postid');
        carTitle = $(this).data('title');
      }
      
    
      if ($('.compare_1.same_bxk').attr('id_car') === undefined && $('.compare_2.same_bxk').attr('id_car') != carLicense) {
        // code for compare 1…
        localStorage.setItem("car_license_1", carLicense);
        // … and so on for the rest of car1 data
    } else if ($('.compare_2.same_bxk').attr('id_car') === undefined && $('.compare_1.same_bxk').attr('id_car') != carLicense) {
        // code for compare 2…
        localStorage.setItem("car_license_2", carLicense);
        // … and so on for the rest of car2 data
    }  
      var post_id = typeof $(this).parent().parent().parent().parent().attr('id_car') === 'undefined' ? $('.grid-single-car.col-12').attr('id_car') : $(this).parent().parent().parent().parent().attr('id_car');
      var image_compare = carImage;
      var title_compare = $(this).parent().parent().siblings('.half_box').children('.title_car').text() === '' ? $('.header-single-car .title_part > h1').text() : $(this).parent().parent().siblings('.half_box').children('.title_car').text();

      if ($('.compare_1.same_bxk').attr('id_car') === undefined && $('.compare_2.same_bxk').attr('id_car') != post_id) {
        $('.compare_1.same_bxk img').attr('src', image_compare);
        $('.compare_1.same_bxk h3').html(title_compare);
        $('.compare_1.same_bxk .remove_item_compare').css('display', 'block');
        $('.compare_1.same_bxk').attr('id_car', post_id);
      } else if ($('.compare_2.same_bxk').attr('id_car') === undefined && $('.compare_1.same_bxk').attr('id_car') != post_id) {
        $('.compare_2.same_bxk img').attr('src', image_compare);
        $('.compare_2.same_bxk h3').html(title_compare);
        $('.compare_2.same_bxk .remove_item_compare').css('display', 'block');
        $('.compare_2.same_bxk').attr('id_car', post_id);
      }

      if (typeof (Storage) !== "undefined") {
        // Store
        localStorage.setItem("image_compare_1", $('.compare_1.same_bxk img').attr('src'));
        localStorage.setItem("title_compare_1", $('.compare_1.same_bxk h3').text());
        localStorage.setItem("post_id_1", $('.compare_1.same_bxk').attr('id_car'));

        localStorage.setItem("image_compare_2", $('.compare_2.same_bxk img').attr('src'));
        localStorage.setItem("title_compare_2", $('.compare_2.same_bxk h3').text());
        localStorage.setItem("post_id_2", $('.compare_2.same_bxk').attr('id_car'));
      }

      if ($('.compare_1.same_bxk').attr('id_car') !== undefined && $('.compare_2.same_bxk').attr('id_car') !== undefined) {
        $('.compare_cars_popup .popup_compare > div > a').css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'initial'
        });
      }

      /* Popup Show */
      $('.compare_cars_popup').fadeIn().animate({'bottom': '0px', 'z-index': '3333'}, 500);

      if (($('.compare_1.same_bxk').attr('id_car') != '') && (typeof $('.compare_2.same_bxk').attr('id_car') == 'undefined') || ($('.compare_2.same_bxk').attr('id_car') != '') && (typeof $('.compare_1.same_bxk').attr('id_car') == 'undefined')) {
        if (integer < 1) {
          $('.special-container.comparation span').html(integer += 1);
        }
      } else if ($('.compare_1.same_bxk').attr('id_car') != '' && $('.compare_2.same_bxk').attr('id_car') != '') {
        if (integer < 2) {
          $('.special-container.comparation span').html(integer += 1);
        }
      }

      var id_match_hover = $(this).parents('.each_part_car').attr('id_car');

      $('.children_compare > .same_bxk').each(function () {
        if (id_match_hover == $(this).attr('id_car')) {
          $('.each_part_car[id_car= ' + $(this).attr('id_car') + ']').addClass('active_hover');
        }
      });

    });

    /*Remove car item */

    $('.remove_item_compare').click(function () {

      var id_match_hover = $(this).parent().attr('id_car');

      $('.content-car .each_part_car').each(function () {
        if (id_match_hover == $(this).attr('id_car')) {
          $(this).removeClass('active_hover');
        }
      });

      $(this).siblings('h3').html('');
      $(this).siblings('img').attr('src', '');
      $(this).css('display', 'none');
      $('.compare_cars_popup .popup_compare > div > a').css({
        'opacity': '30%',
        'cursor': 'default',
        'pointer-events': 'none'
      });

      if ($('.compare_1.same_bxk h3').html() == '' && $('.compare_2.same_bxk h3').html() == '') {
        $('.compare_cars_popup').animate({'bottom': '-253px'}, 500).fadeOut();
      }

    });

    $('.compare_1.same_bxk .remove_item_compare').click(function () {
      localStorage.removeItem('car_license_1')
      localStorage.removeItem("image_compare_1");
      localStorage.removeItem("title_compare_1");
      localStorage.removeItem("post_id_1");

      $('.compare_1.same_bxk .hidden_element > div').html('');
      $('.compare_1.same_bxk').removeAttr('id_car');
      $('.special-container.comparation span').html(integer -= 1);

    });
    $('.compare_2.same_bxk .remove_item_compare').click(function () {
      localStorage.removeItem('car_license_2')
      localStorage.removeItem("image_compare_2");
      localStorage.removeItem("title_compare_2");
      localStorage.removeItem("post_id_2");
      $('.compare_2.same_bxk').removeAttr('id_car');
      $('.special-container.comparation span').html(integer -= 1);

      $('.compare_2.same_bxk .hidden_element > div').html('');

    });

    if (typeof (Storage) !== "undefined") {
      if (((localStorage.getItem("image_compare_1") != null) || (localStorage.getItem("title_compare_1") != null)) && (localStorage.getItem("image_compare_1") != '')) {
        /*car 1*/
        $('.compare_1.same_bxk img').attr('src', localStorage.getItem("image_compare_1"));
        $('.compare_1.same_bxk').attr('id_car', localStorage.getItem("post_id_1"));
        $('.compare_1.same_bxk h3').text(localStorage.getItem("title_compare_1"));

        $('.compare_1.same_bxk .item_1').text(localStorage.getItem("item_car_1"));
        $('.compare_1.same_bxk .item_2').text(localStorage.getItem("item_car_2"));
        $('.compare_1.same_bxk .item_3').text(localStorage.getItem("item_car_3"));
        $('.compare_1.same_bxk .item_4').text(localStorage.getItem("item_car_4"));
        $('.compare_1.same_bxk .item_5').text(localStorage.getItem("item_car_5"));

        $('.compare_1.same_bxk .item_car1').text(localStorage.getItem("options_1"));
        $('.compare_1.same_bxk .item_car2').text(localStorage.getItem("options_2"));
        $('.compare_1.same_bxk .item_car3').text(localStorage.getItem("options_3"));
        $('.compare_1.same_bxk .item_car4').text(localStorage.getItem("options_4"));
        $('.compare_1.same_bxk .item_car5').text(localStorage.getItem("options_5"));
        $('.compare_1.same_bxk .item_car6').text(localStorage.getItem("options_6"));
        $('.compare_1.same_bxk .item_car_promotions').text(localStorage.getItem("option_promotions"));
        $('.compare_1.same_bxk .warrnety_months').text(localStorage.getItem("warrnety_months"));

        if ((localStorage.getItem("image_compare_1") != '') && (localStorage.getItem("title_compare_1") != '')) {
          $('.compare_1.same_bxk .remove_item_compare').css('display', 'block');
        }

        //$('.compare_cars_popup').fadeIn().animate({'bottom':'20%', 'z-index': '3'}, 500);
      }
      if (((localStorage.getItem("image_compare_2") != null) || (localStorage.getItem("title_compare_2") != null)) && (localStorage.getItem("image_compare_2") != '')) {
        /*car 2*/
        $('.compare_2.same_bxk img').attr('src', localStorage.getItem("image_compare_2"));
        $('.compare_2.same_bxk').attr('id_car', localStorage.getItem("post_id_2"));
        $('.compare_2.same_bxk h3').text(localStorage.getItem("title_compare_2"));

        $('.compare_2.same_bxk .item_1').text(localStorage.getItem("item_car_2_1"));
        $('.compare_2.same_bxk .item_2').text(localStorage.getItem("item_car_2_2"));
        $('.compare_2.same_bxk .item_3').text(localStorage.getItem("item_car_2_3"));
        $('.compare_2.same_bxk .item_4').text(localStorage.getItem("item_car_2_4"));
        $('.compare_2.same_bxk .item_5').text(localStorage.getItem("item_car_2_5"));

        $('.compare_2.same_bxk .item_car1').text(localStorage.getItem("options_2_1"));
        $('.compare_2.same_bxk .item_car2').text(localStorage.getItem("options_2_2"));
        $('.compare_2.same_bxk .item_car3').text(localStorage.getItem("options_2_3"));
        $('.compare_2.same_bxk .item_car4').text(localStorage.getItem("options_2_4"));
        $('.compare_2.same_bxk .item_car5').text(localStorage.getItem("options_2_5"));
        $('.compare_2.same_bxk .item_car6').text(localStorage.getItem("options_2_6"));
        $('.compare_2.same_bxk .item_car_promotions').text(localStorage.getItem("option_promotions_2"));
        $('.compare_2.same_bxk .warrnety_months').text(localStorage.getItem("warrnety_months_2"));

        if ((localStorage.getItem("image_compare_2") != '') && (localStorage.getItem("title_compare_2") != '')) {
          $('.compare_2.same_bxk .remove_item_compare').css('display', 'block');
        }
        //$('.compare_cars_popup').fadeIn().animate({'bottom':'20%', 'z-index': '3'}, 500);
      }
      if (localStorage.getItem("image_compare_2") != null && localStorage.getItem("image_compare_1") != null && (localStorage.getItem("image_compare_2") != '') && (localStorage.getItem("image_compare_1") != '')) {
        $('.compare_cars_popup .popup_compare > div > a').css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'initial'
        });
      }
      if ((typeof $('.compare_2.same_bxk').attr('id_car') == 'undefined') && (typeof $('.compare_1.same_bxk').attr('id_car') == 'undefined')) {
      } else if (($('.compare_1.same_bxk').attr('id_car') != '') && (typeof $('.compare_2.same_bxk').attr('id_car') == 'undefined') || ($('.compare_2.same_bxk').attr('id_car') != '') && (typeof $('.compare_1.same_bxk').attr('id_car') == 'undefined')) {
        if (integer < 1) {
          $('.special-container.comparation span').html(integer += 1);
        }
      } else if ($('.compare_1.same_bxk').attr('id_car') != '' && $('.compare_2.same_bxk').attr('id_car') != '') {
        if (integer < 2) {
          $('.special-container.comparation span').html(integer += 2);
        }
      }
    }

    $('.children_compare > .same_bxk').each(function () {
      $('.each_part_car[id_car= ' + $(this).attr('id_car') + ']').addClass('active_hover');
    });

    /*Close Window Popup*/

    $('.close_compare_popup').click(function () {

      $('.compare_cars_popup').animate({'bottom': '-252px'}, 500).fadeOut();

    });


    $('.popup_compare.site-row .children_compare a').click(function () {

      /*Car 1*/
      var check_car_1 = $('.compare_1.same_bxk .hidden_element .item_car2').html();
      var km_car_1 = $('.compare_1.same_bxk .hidden_element .item_car4').html();
      var location_car_1 = $('.compare_1.same_bxk .hidden_element .item_car3').html();
      var people_car_1 = $('.compare_1.same_bxk .hidden_element .item_car5').html();
      var price_car_1 = $('.compare_1.same_bxk .hidden_element .item_car1').html();
      var promotions_car_1 = $('.compare_1.same_bxk .hidden_element .item_car_promotions').html();
      var warrnety_months_1 = $('.compare_1.same_bxk .hidden_element .warrnety_months').html();

      var aa_car_1 = $('.compare_1.same_bxk .hidden_element .item_1').html();
      var engine_car_1 = $('.compare_1.same_bxk .hidden_element .item_2').html();
      var gearbox_car_1 = $('.compare_1.same_bxk .hidden_element .item_3').html();
      var oil_car_1 = $('.compare_1.same_bxk .hidden_element .item_4').html();
      var color_car_1 = $('.compare_1.same_bxk .hidden_element .item_5').html();

      var car_discount_1 = $('.compare_1.same_bxk .hidden_element .item_car6').html();
      /*Car 2*/
      var check_car_2 = $('.compare_2.same_bxk .hidden_element .item_car2').html();
      var km_car_2 = $('.compare_2.same_bxk .hidden_element .item_car4').html();
      var location_car_2 = $('.compare_2.same_bxk .hidden_element .item_car3').html();
      var people_car_2 = $('.compare_2.same_bxk .hidden_element .item_car5').html();
      var price_car_2 = $('.compare_2.same_bxk .hidden_element .item_car1').html();
      var promotions_car_2 = $('.compare_2.same_bxk .hidden_element .item_car_promotions').html();
      var warrnety_months_2 = $('.compare_2.same_bxk .hidden_element .warrnety_months').html();

      var aa_car_2 = $('.compare_2.same_bxk .hidden_element .item_1').html();
      var engine_car_2 = $('.compare_2.same_bxk .hidden_element .item_2').html();
      var gearbox_car_2 = $('.compare_2.same_bxk .hidden_element .item_3').html();
      var oil_car_2 = $('.compare_2.same_bxk .hidden_element .item_4').html();
      var color_car_2 = $('.compare_2.same_bxk .hidden_element .item_5').html();

      var car_discount_2 = $('.compare_2.same_bxk .hidden_element .item_car6').html();

      /* Car Compare 1*/
      var path_image_1 = $('.compare_1.same_bxk > img').attr('src');
      var name_car_1 = $('.compare_1.same_bxk > h3').text();

      /*Car Compare 2*/
      var path_image_2 = $('.compare_2.same_bxk > img').attr('src');
      var name_car_2 = $('.compare_2.same_bxk > h3').text();

      //Get link to car
      var car_link_1 = '';
      var car_link_2 = '';

      var license1 = localStorage.getItem("car_license_1");
      var license2 = localStorage.getItem("car_license_2");

      // Option 1: Redirect with GET parameters:
      


      $('.each_part_car.active_hover .car_single_btn a').each(function (index) {
        if (!index) {
          car_link_1 = $(this).attr("href");
        } else {
          car_link_2 = $(this).attr("href");
        }
      })
      window.location.href = '/compare?license1=' + encodeURIComponent(license1) + '&license2=' + encodeURIComponent(license2);

      $.ajax({
        type: "GET",
        async: true,
        url: "/compare",
        data: {
          car_link_1: car_link_1,
          car_image_1: path_image_1,
          car_title_1: name_car_1,
          check_car_1: check_car_1,
          location_car_1: location_car_1,
          km_car_1: km_car_1.split(" ")[0],
          people_car_1: people_car_1,
          price_car_1: price_car_1.split(" ")[0],
          car_discount_1: car_discount_1,
          aa_car_1: aa_car_1,
          engine_car_1: engine_car_1,
          gearbox_car_1: gearbox_car_1,
          oil_car_1: oil_car_1,
          color_car_1: color_car_1,
          promotions_car_1: promotions_car_1,
          warrnety_months_1: warrnety_months_1,
          car_link_2: car_link_2,
          car_image_2: path_image_2,
          car_title_2: name_car_2,
          check_car_2: check_car_2,
          location_car_2: location_car_2,
          km_car_2: km_car_2.split(" ")[0],
          people_car_2: people_car_2,
          price_car_2: price_car_2.split(" ")[0],
          car_discount_2: car_discount_2,
          aa_car_2: aa_car_2,
          engine_car_2: engine_car_2,
          gearbox_car_2: gearbox_car_2,
          oil_car_2: oil_car_2,
          color_car_2: color_car_2,
          promotions_car_2: promotions_car_2,
          warrnety_months_2: warrnety_months_2
        },
        success: function (msg) {
        },
        error: function (err) {
        }
      });

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

const refToPhoneNumber = {
  '2yad1': '0772305085',
  '10yad1':  '0772305059',
  '20km': '0777299297',
  '104': '0772305023',
  '100km':  '0779969505',
  '162': '0778044010',
}

function getPhoneNumberID(){
  var ref =  JSON.parse(localStorage.getItem("ref"));
  if(ref){
    if(ref.result == "2" || ref.result == "10"){
      var utm_content = JSON.parse(localStorage.getItem("utm_content"))
      if(utm_content && utm_content.result){
        return ref.result+utm_content.result;
      }
    }
    else
      return ref.result;
  }
  return null;
}


function valideTime(){
  var display_from = document.getElementById('display_from')? document.getElementById('display_from').value : null
  var display_until = document.getElementById('display_until')? document.getElementById('display_until').value : null
  if(!display_from || !display_until)
    return false;
  var d = new Date();
  var timeNow = new Date("1970-01-01 "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds());
  var timeStart = new Date("1970-01-01 " + display_from);
  var timeEnd = new Date("1970-01-01 " + display_until);

  if(timeNow > timeStart && timeNow < timeEnd)
    return true;
  return false;
}

// export const setPhoneNumber = function(className){
// // export function setPhoneNumber(className){
//   var phoneId = getPhoneNumberID();
//   if(phoneId){
//     var phoneNumber = refToPhoneNumber[phoneId] ? refToPhoneNumber[phoneId] : null;
//     // if(phoneNumber && valideTime())
//     if(phoneNumber)
//       $(`.${className}`).prop('href', "tel:"+phoneNumber);
//   }
// }

export const getPhoneNumber = function(){
// export function setPhoneNumber(className){
  var phoneId = getPhoneNumberID();
  if(phoneId){
    return refToPhoneNumber[phoneId] ? refToPhoneNumber[phoneId] : null;
  }
  return null;
}




// WEBPACK FOOTER //
// ./scripts/routes/common.js